import React, { Component } from "react";
import PropTypes from "prop-types";

class ValidationInput extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        return (this.props.label !== nextProps.label) ||
               (this.props.value !== nextProps.value) ||
               (this.props.autoFocus !== nextProps.autoFocus) ||
               (this.props.isValid !== nextProps.isValid) ||
               (this.props.errorMessage !== nextProps.isValid) ||
               (this.props.inputClassName !== nextProps.inputClassName);
    }

    render() {
        const props = this.props;

        let labelActiveClasses = (props.value) ? "input-label-active " : "";

        let labelDisplay;
        if (props.label) {
            labelDisplay = (
                <label className={ "input-label " + labelActiveClasses }>
                    { props.label }
                </label>
            );
        }

        let errorDisplay;
        if (!props.isValid) {
            errorDisplay = <div className="error-text">{ props.errorMessage }</div>;
        }

        return (
            <span className={ props.isValid ? "validation-input-wrapper" : "validation-input-wrapper invalid-input" }>
                <input className={ "validation-input " + props.inputClassName}
                       onKeyUp={ function(event) {
                           if (event.key === "Enter") {
                               props.handleEnterClick(event);
                           }
                       }}
                       onChange={ props.handleChange }
                       onBlur={ props.handleBlur }
                       value={ props.value }
                       autoFocus={ props.autoFocus }
                />
                <hr className="active-border"/>
                <hr className="bottom-border"/>
                { labelDisplay }
                { errorDisplay }
            </span>
        );
    }
}

ValidationInput.propTypes = {
    autoFocus: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string.isRequired,
    handleBlur: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleEnterClick: PropTypes.func.isRequired,
    inputClassName: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

export default ValidationInput;
